module.exports = __webpack_public_path__ + "static/media/Khushi_Pattanshetti.1bc48b65.jpeg";